import Config from '../Config.json';
import axios from 'axios';
import {random} from 'lodash';

//generate a random name for config 
const name = "Config" + random(123233,false);

export default class ConfigUtility {
  public static get(): Promise<typeof Config> {

    // Actually have to use the Config object to ensure it get imported
    if (Config?.EnableBugSnag) {
    }

    if(this.globalConfig) {
      return Promise.resolve(this.globalConfig as typeof Config);
    }

    const configString =  sessionStorage.getItem('config');
    if (!configString) {
      return axios.get(`/Config.json?v=${name}`,{ method:'POST' ,headers: {'Cache-Control': 'max-age=10'}}).then(x => {
        this.globalConfig = x.data;
        //sessionStorage.setItem('config', JSON.stringify(x.data));
        return x.data;
      });
    } else {
      const config = JSON.parse(configString);
      return Promise.resolve(config as typeof Config);
    }
  }

  public static getSync(): typeof Config | undefined {

    if(this.globalConfig) {
      return this.globalConfig ;
    }

    const configString = sessionStorage.getItem('config');

    if (!configString) {
      return undefined;
    }

    const config = JSON.parse(configString);
    this.globalConfig = config;
    return config;
  }

  static get globalConfig(): typeof Config {
    return (window as any)[name];
  }

  static set globalConfig(value: typeof Config) {
     (window as any)[name] = value;
  }
}
